import React, { useEffect, useState } from "react";
import CustomSlider from "../SliderCards/CustomSlider";
import { SwiperSlide } from "swiper/react";
// import icon from "../../assets/Svg/discount-card.svg";
import discountCardFull from "../../assets/Svg/dis-10.svg";
import discountCard5 from "../../assets/Svg/dis-5.svg";
import freeShipping from "../../assets/Svg/free-ship.svg";
import DashboardLogo from "../../assets/Svg/dashboard-logo.svg";
import { Image } from "@nextui-org/react";
import download from "../../assets/Svg/download.svg";

const CardSlider = ({
  fivePercentDiscount,
  tenPercentDiscount,
  pwa,
  storeImage,
  name,
}) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installable, setInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(
    window.matchMedia("(display-mode: standalone)").matches
  );
  useEffect(() => {
    const checkStandaloneMode = () => {
      if (window.matchMedia("(display-mode: standalone)").matches) {
        setIsInstalled(true);
      }
    };

    checkStandaloneMode();
    const handleBeforeInstallPrompt = (e) => {
      // console.log("beforeinstallprompt event fired");
      e.preventDefault();
      window.deferredPrompt = e;
      setDeferredPrompt(e);
      setInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = async () => {
    const promptEvent = deferredPrompt || window.deferredPrompt;
    if (!promptEvent) {
      // console.log("No install prompt available.");
      return;
    }

    // console.log("Showing install prompt...");
    await promptEvent.prompt();

    // if (outcome === "accepted") {
    //   console.log("User installed the app.");
    // } else {
    //   console.log("User dismissed the install prompt.");
    // }

    setDeferredPrompt(null);
    setInstallable(false);
    window.deferredPrompt = null;
  };

  return (
    <CustomSlider
      productImagesSize={3}
      // autoplay={true}
      loop={true}
      spaceBetween={2}
      //   pagination={pagination}
      footNavigation={true}
      breakpoints={{
        320: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 2,
        },
      }}
      referrer="cards"
      childLength={
        tenPercentDiscount || fivePercentDiscount
          ? pwa && !isInstalled && installable
            ? 3
            : 2
          : pwa && !isInstalled && installable
          ? 2
          : 1
      }
    >
      {/* <SwiperSlide key={0}>{freeDeliveryCard(freeDelivery)}</SwiperSlide> */}
      <SwiperSlide key={0}>
        {<img src={freeShipping} alt="tag"></img>}
      </SwiperSlide>

      {(tenPercentDiscount || fivePercentDiscount) && (
        <SwiperSlide key={1}>
          {
            <img
              src={
                tenPercentDiscount
                  ? discountCardFull
                  : fivePercentDiscount
                  ? discountCard5
                  : null
              }
              alt="tag"
            ></img>
          }
        </SwiperSlide>
      )}
      {pwa && !isInstalled && installable && (
        <SwiperSlide key={2}>
          <div className="">
            {PWAButton(storeImage, name, handleInstallClick)}
          </div>
        </SwiperSlide>
      )}

      {/* {fivePercentDiscount && (
        <SwiperSlide key={2}>{<img src={discountCard5}></img>}</SwiperSlide>
      )} */}

      {/* <SwiperSlide key={1}>{discountCard(icon)}</SwiperSlide> */}
    </CustomSlider>
  );
};

export default CardSlider;

// const freeDeliveryCard = (freeDelivery) => {
//   return (
//     <div className="w-full my-2  p-1.5 bg-gradient-to-r from-[#21314a] to-[#4862ee] rounded-xl shadow-[0px_0px_10px_0px_rgba(0,0,0,0.25)] border-2 border-[#17c964] justify-start items-center gap-2 inline-flex overflow-hidden">
//       <img src={freeDelivery} alt="free delivery" className="w-16 h-16" />
//       <div className="grow shrink basis-0 flex-col justify-center items-start gap-1 inline-flex py-2">
//         <div className="self-stretch text-white text-sm font-normal leading-[18px] tracking-tight">
//           Free shipping on pre-paid orders over ₹499.{" "}
//         </div>
//         <div className="self-stretch text-[#eceff2] text-xs font-light leading-[18px] tracking-tight">
//           COD available for orders over ₹499 and up to ₹6000
//         </div>
//       </div>
//     </div>
//   );
// };

// const discountCard = (icon) => {
//   return (
//     <div className="w-full my-2 p-1.5 bg-gradient-to-r from-[#431505] to-[#f7c052] rounded-xl shadow-[0px_0px_10px_0px_rgba(0,0,0,0.25)] border-2 border-[#f7c052] justify-start items-center gap-2 inline-flex overflow-hidden">
//       <img src={icon} alt="free delivery" className="w-8 h-8" />

//       <div className="grow shrink basis-0 flex-col justify-center items-start gap-1 inline-flex py-3">
//         <div className="self-stretch text-white text-sm font-normal leading-[18px] tracking-tight">
//           Get 10% off on everything.
//         </div>
//         <div className="self-stretch text-[#eceff2] text-xs font-light leading-[18px] tracking-tight">
//           Enjoy discounts on all items when you spend over ₹599!
//         </div>
//       </div>
//     </div>
//   );
// };

const PWAButton = (storeImage, name, handleInstallClick) => {
  return (
    <div className="bg-[#F0F3FE] px-2 py-4  rounded-lg">
      <div className="flex justify-between items-center">
        <div className="flex items-center ">
          <div className="flex-shrink-0">
            <Image
              src={storeImage || DashboardLogo}
              alt="wcommlogo"
              width={40}
              height={40}
              radius="md"
            />
          </div>
          <div className="text-[#21314a] text-sm font-normal leading-tight tracking-tight pl-2">
            Add {name} app to home screen
          </div>
        </div>
        <div
          className="w-10 h-10 bg-[#4862ee] rounded-lg justify-center items-center flex-shrink-0 gap-2.5 inline-flex cursor-pointer"
          onClick={handleInstallClick}
        >
          <Image
            src={download}
            alt="download"
            width={25}
            height={25}
            radius="md"
          />
        </div>
      </div>
    </div>
  );
};
